import React from 'react';
import { translate } from 'react-i18next';

import PasswordFieldWithValidation from 'components/PasswordFieldWithValidation';

class ConfirmableFieldPair extends React.Component {
  constructor(props) {
    super(props);

    this.compare = this.compare.bind(this);
    this.remoteValidator = _.debounce(this.remoteValidator, 700);

    this.state = {
      inputClass: 'initialized',
      errorMessages: undefined,
      passwordValidated: false,
      valid: false,
      confirmed: false,
      password: {
        valid: false,
        value: '',
        inputClass: 'initialized',
      },
      password_confirmation: {
        valid: false,
        value: '',
        inputClass: 'initialized',
      },
    };
    this.initialState = _.clone(this.state);
  }

  componentWillUnmount() {
    AccountStore.off(null, null, this);
    this.initialState = {};
  }

  componentDidMount() {
    AccountStore.on(
      'password:validate:failure',
      function (data) {
        this.setState({
          valid: false,
          passwordValidated: false,
          errorMessages: data,
        });
        this.props.handleChange('password', this.state.password.value, false);
      },
      this,
    );

    AccountStore.on(
      'password:validate:success',
      function () {
        this.setState({
          valid: this.state.passwordConfirmed,
          passwordValidated: true,
          errorMessages: undefined,
          password: {
            value: this.state.password.value,
            valid: true,
          },
        });
        this.props.handleChange('password', this.state.password.value, true);
      },
      this,
    );

    AccountStore.on(
      'password:update:success',
      function (data) {
        this.setState(this.initialState);
      },
      this,
    );
  }

  componentWillReceiveProps() {
    this.setState({
      inputClass: this.props.inputClass,
    });
  }

  compare(value1, value2) {
    return value1 === value2;
  }

  remoteValidator(password) {
    MakeShiftEmployeeDispatcher.dispatch({
      actionType: appConstants.ActionTypes.PASSWORD_VALIDITY,
      postData: {
        password,
      },
    });
  }

  handlePasswordConfirmationChange(value, valid) {
    const confirmed = this.compare(value, this.state.password.value);
    var valid = confirmed && this.state.passwordValidated;
    this.setState({
      valid,
      confirmed,
      password_confirmation: {
        value,
        valid,
      },
    });
    this.props.handleChange('password_confirmation', value, valid);
  }

  handlePasswordChange(value, valid) {
    valid = this.remoteValidator(value);
    this.setState({
      valid: this.compare(value, this.state.password.value) && this.passwordValidated,
      confirmed: this.compare(value, this.state.password_confirmation.value),
      password: {
        value,
        valid,
      },
    });
  }

  passwordInputClass() {
    if (this.state.password.inputClass == 'initialized') {
      return 'initialized';
    }

    if (this.state.password.valid) {
      return 'valid';
    }
    if (!this.state.password.valid) {
      return 'error';
    }
  }

  passwordConfirmationInputClass() {
    if (this.state.password_confirmation.inputClass == 'initialized') {
      return 'initialized';
    }

    if (this.state.confirmed) {
      return 'valid';
    }

    if (!this.state.confirmed) {
      return 'error';
    }
  }

  confirmPasswordErrorMessages() {
    const messages = [];
    // if empty no message
    if (this.state.password_confirmation.value != '') {
      if (this.state.password_confirmation.value != this.state.password.value) {
        messages.push(this.props.t('ConfirmableFieldPair.password_does_not_match'));
      }
    }
    return messages;
  }

  render() {
    let { errorMessages } = this.state;
    const passwordValue = this.state.password.value;
    const passwordConfirmationValue = this.state.password_confirmation.value;
    let passwordErrorMessages = '';
    let confirmPasswordErrorMessages = this.confirmPasswordErrorMessages();

    if (errorMessages) {
      passwordErrorMessages = (
        <div className="error-messages">
          {errorMessages}
        </div>
      );
    }

    if (this.props.valid == true) {
      errorMessages = '';
    } else {
      errorMessages = this.props.errorMessages;
    }

    let validAsPair = false;
    if (this.props.valid == true) {
      validAsPair = true;
    }

    return (
      <div className="password-confirmation-set">
        <PasswordFieldWithValidation
          inputClass={this.passwordInputClass()}
          name="password"
          label={this.props.t('ConfirmableFieldPair.new_password')}
          placeholder={this.props.t('ConfirmableFieldPair.minimum_8_characters')}
          validations={[]}
          value={passwordValue}
          passwordConfirmed={this.props.passwordConfirmed}
          valid={this.state.password.valid}
          errorMessages={passwordErrorMessages}
          handleChange={this.handlePasswordChange.bind(this)}
          activeState={this.props.activeState}
        />
        <p className="instructional">{this.props.t('ConfirmableFieldPair.password_instructions')}:</p>
        <ol className="instructional">
          <li>{this.props.t('ConfirmableFieldPair.uppercase_letter')},</li>
          <li>{this.props.t('ConfirmableFieldPair.lowercase_letter')},</li>
          <li>{this.props.t('ConfirmableFieldPair.number')},</li>
          <li>{this.props.t('ConfirmableFieldPair.special_character')}.</li>
        </ol>
        <p className="instructional last">
          {this.props.t('ConfirmableFieldPair.password_instructions_last')}
        </p>
        <PasswordFieldWithValidation
          className="confirmation"
          inputClass={this.passwordConfirmationInputClass()}
          name="password_confirmation"
          label={this.props.t('ConfirmableFieldPair.confirm_password')}
          placeholder={this.props.t('ConfirmableFieldPair.minimum_8_characters')}
          validations={[]}
          value={passwordConfirmationValue}
          onValidateFunction={this.compare}
          passwordConfirmed={this.props.passwordConfirmed}
          valid={this.state.passwordValidated}
          errorMessages={confirmPasswordErrorMessages}
          handleChange={this.handlePasswordConfirmationChange.bind(this)}
          activeState={this.props.activeState}
        />
      </div>
    );
  }
}

export default translate()(ConfirmableFieldPair);
